import Button from "../../Custom/Button/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import MailUpdate from "./MailUpdate";
import "./customPost.css";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";

const CustomPost = ({
  setCheckBack,
  checkBack,
  setCustom,
  custom,
  setMail,
  selectedCompany,
  currentTab,
}) => {
  const settingState = () => {
    const keys = Object.keys(custom.data[0] || custom.properties);
    let newState = {};
    keys.forEach((key) => {
      if (key !== "id") newState[`${key}`] = "";
    });
    return newState;
  };
  const [selected, setSelected] = useState(null);
  const [updated, setUpdated] = useState({
    value: false,
    user: undefined,
  });
  const [usersData, setUsersData] = useState(custom.data);
  const { baseUrl, activeStates, setActiveStates } = useGlobalContext();
  const { loggedUser, apiKey } = useGlobalContext();

  const [updatedAddress, setUpdatedAddress] = useState(null);

  const handleSelected = (user) => {
    if (selected?.id === user.id) {
      setSelected(null);
    } else setSelected(user);
  };

  const handleAddActive = (cond, user) => {
    setCheckBack(true);
    if (cond) {
      setUpdated({
        user,
        value: true,
      });
      setUpdatedAddress(user);
    } else {
      setUpdatedAddress(settingState());
    }
  };

  const createObject = (user) => {
    switch (custom.name) {
      case "Adresar": {
        return {
          url: `${baseUrl}/admin_panel/address_book/delete.php`,
          data: {
            address_book_id: user.id,
            user_id: loggedUser.id,
            api_key: apiKey,
            company_id: parseInt(selectedCompany.company_id),
          },
        };
      }
      case "Imenik": {
        return {
          url: `${baseUrl}/admin_panel/phonebook/delete.php`,
          data: {
            phonebook_id: user.id,
            user_id: loggedUser.id,
            api_key: apiKey,
            company_id: parseInt(selectedCompany.company_id),
          },
        };
      }
      case "Mesta": {
        return {
          url: `${baseUrl}/admin_panel/company_places/delete.php`,
          data: {
            company_place_id: user.id,
            user_id: loggedUser.id,
            api_key: apiKey,
            company_id: parseInt(selectedCompany.company_id),
          },
        };
      }
      default: {
      }
    }
  };

  const handleDelete = async (user) => {
    try {
      const newObject = createObject(user);
      const response = await axios.post(newObject.url, newObject.data);
      const newUsers = usersData.filter((current) => current.id !== user.id);
      setUsersData(newUsers);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!checkBack) setUpdated({ value: false, user: undefined });
  }, [checkBack]);

  useEffect(() => {
    setUsersData(custom.data);
  }, [custom.data]);

  useEffect(() => {
    const currentActiveState = activeStates.find(
      (state) => state.name === currentTab
    )?.data;
    if (currentActiveState !== undefined) {
      setCustom(currentActiveState.custom);
      setSelected(currentActiveState.selected);
      setCheckBack(currentActiveState.checkBack);
      setUpdatedAddress(currentActiveState.updatedAddress);
      setUpdated(currentActiveState.updated);
    }
  }, [currentTab]);

  useEffect(() => {
    const newActiveState = {
      name: currentTab,
      data: {
        custom,
        selected,
        checkBack,
        updatedAddress,
        updated,
      },
    };
    const currentActive = activeStates.find(
      (state) => state.name === currentTab
    );
    if (currentActive !== undefined) {
      const newActiveStates = activeStates.map((state) => {
        if (state.name === currentTab) {
          return {
            name: currentTab,
            data: {
              custom,
              selected,
              checkBack,
              updatedAddress,
              updated,
            },
          };
        } else return state;
      });
      setActiveStates(newActiveStates);
    } else {
      setActiveStates([...activeStates, newActiveState]);
    }
  }, [selected, custom, updatedAddress, updated, checkBack]);

  return (
    <>
      {!checkBack ? (
        <div className="wrapper-mail">
          <div className="wrapper-mail-navbar">
            <h4>{custom.name}</h4>
            <div
              className="button-mail"
              onClick={() => handleAddActive(false, undefined)}
            >
              <Button activation={true}>
                <AddIcon />
              </Button>
            </div>
          </div>
          {custom.data.length !== 0 && (
            <div className="wrapper-mail-users">
              {usersData.length > 0 &&
                usersData.map((user, index) => {
                  return (
                    <div className="wrapper-mail-user" key={index}>
                      <div
                        className="wrapper-mail-user-name"
                        onClick={() => handleSelected(user)}
                      >
                        <Button active={selected?.id === user.id}>
                          {user.name}
                        </Button>
                      </div>
                      <div
                        className="wrapper-mail-user-edit"
                        onClick={() => handleAddActive(true, user)}
                      >
                        <Button activation={true}>
                          <EditIcon />
                        </Button>
                      </div>
                      <div
                        className="wrapper-mail-user-edit"
                        onClick={() => handleDelete(user)}
                      >
                        <Button activation={true}>
                          <DeleteIcon />
                        </Button>
                      </div>
                      {selected && selected.id === user.id && (
                        <div className="mail-selected-user">
                          {custom.name === "Adresar" && (
                            <a href={`mailto:${selected.email}`}>
                              {selected.email}
                            </a>
                          )}
                          {custom.name === "Imenik" && (
                            <a href={`tel:${selected.data}`}>{selected.data}</a>
                          )}
                          {custom.name === "Mesta" && (
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query="${selected.name} ${selected.adress} ${selected.town}`}
                            >
                              {selected.adress} {selected.town}
                            </a>
                          )}
                          <div className="triangle" />
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      ) : (
        <MailUpdate
          setCheckBack={setCheckBack}
          usersData={usersData}
          setUsersData={setUsersData}
          userUpdate={updated}
          setUpdated={setUpdated}
          custom={custom}
          setCustom={setCustom}
          setMail={setMail}
          selectedCompany={selectedCompany}
          selected={selected}
          checkBack={checkBack}
          currentTab={currentTab}
          updatedAddress={updatedAddress}
          setUpdatedAddress={setUpdatedAddress}
        />
      )}
    </>
  );
};

export default CustomPost;
